import React, { ReactNode } from 'react';
import { Icon } from 'js/design_system/Icon';

import 'app/assets/stylesheets/design_system/form.scss';

type ErrorsProps = React.HTMLProps<HTMLDivElement> & {
  errors?: ReactNode[];
};

export const Errors: React.FC<ErrorsProps> = ({ errors = [], ...props }) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <div {...props}>
      {errors.map((error, index) => (
        <div className="ds2-5-form--error-msg" key={index}>
          <Icon name="warning" />
          {error}
        </div>
      ))}
    </div>
  );
};
